<template>
  <div v-if="$fetchState.pending" class="my-addresses__loading">
    <logo-loading />
  </div>
  <p v-else-if="$fetchState.error">
    {{ $t('product.fetch_failed') }}
    <a rel="nofollow" @click.prevent="$fetch">{{
      $t('product.retry_fetch')
    }}</a>
  </p>
  <div v-else-if="!addresses.length" class="my-addresses__empty">
    <p id="users-address-list-empty">
      {{ $t('address_book.no_shipping_addresses_on_file') }}
    </p>
    <v-button block @click="gotoNewAddress">
      {{ $t('address_book.add_new_shipping_address') }}
    </v-button>
  </div>
  <transition v-else name="fade">
    <div v-if="!$fetchState.pending && addresses.length">
      <ul class="block-list">
        <my-address
          v-for="address in addresses"
          :key="address.id"
          :address="address"
        />
      </ul>
      <v-button block @click="gotoNewAddress">
        {{ $t('address_book.add_new_shipping_address') }}
      </v-button>
    </div>
  </transition>
</template>

<script>
import MyAddress from './my-address/MyAddress'
import LogoLoading from '~/components/loadings/logo'
import VButton from '~/components/v-button/VButton'

export default {
  name: 'MyAddresses',
  components: {
    LogoLoading,
    MyAddress,
    VButton,
  },
  async fetch() {
    try {
      const { data: addresses } = await this.$apiv2.get('addresses', {
        params: this.$store.getters.storeInfo,
      })

      this.addresses = addresses
    } catch (err) {
      this.$displayTopMessage(this.$t('action_error'), {
        type: 'error',
      })
    }
  },
  data() {
    return {
      addresses: [],
    }
  },
  methods: {
    gotoNewAddress() {
      this.$router.push('/addresses/new')
    },
  },
}
</script>

<style lang="scss">
@import '~/assets/css/block-list.scss';
</style>
